// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e77a1ebb","453":"35a4443e","455":"23457d5e","977":"fc5c5c50"}[chunkId] + ".chunk.js";
};